import type { FC } from "react";

import { MerchantProductsCard } from "@src/components";

type ProductsPageProps = object;

export const ProductsPage: FC<ProductsPageProps> = () => {
    return <MerchantProductsCard />;
};
